module.exports = __webpack_public_path__ + "assets/hostingpage-605906309934ec014b09335f747da4ec.png";


//////////////////
// WEBPACK FOOTER
// ./pages/Helpdesk/assets/hostingpage.png
// module id = 632
// module chunks = 0 1